/**
 * Telegram Mini App wrapper for the practice review page.
 * URL: /tg/practice-history/:sessionId
 */

import React from 'react';
import TelegramShell from '../components/TelegramShell';
import PracticeReview from './PracticeReview';

const TelegramPracticeReview: React.FC = () => (
  <TelegramShell>
    <PracticeReview />
  </TelegramShell>
);

export default TelegramPracticeReview;
